import AssignmentScheduleCalendar from './AssignmentScheduleCalendar';

export default AssignmentScheduleCalendar;
